import styled from 'styled-components'
import PropTypes from 'prop-types'

import { features } from '@h2/components/media'
import { Box as BoxBase } from '@h2/components/layout/box'
import { Fade as FadeBase } from '@h2/components/animations/fade'

const Box = styled(BoxBase)`
  grid-area: cnt;
  padding: 30px 20px;

  @media (${features.minWidth.laptop}) {
    padding: 40px;
  }
`
const Fade = styled(FadeBase)`
  height: 100%;
`
const Content = ({ children, fade = true }) => {
  if (fade) {
    return (
      <Box>
        <Fade timeout={350} appear in>
          {children}
        </Fade>
      </Box>
    )
  }

  return <Box>{children}</Box>
}

Content.propTypes = {
  fade: PropTypes.bool,
  children: PropTypes.node.isRequired
}
Content.slotName = 'PanelContent'

export { Content }
